<template>
  <div class="alert-tooltip z-10 aisea-text-14-400-white pl-1">
    <div class="alert-title">
      <slot name="alert-title" />
    </div>
    <div class="alert-item">
      <slot name="alert-item" />
    </div>
  </div>
</template>
<script>
export default {
  name: "AlertTooltip",
  components: {},
};
</script>
<style lang="scss">
.alert-tooltip {
  .alert-title {
    margin-bottom: 10px;
  }
  .alert-item {
    font-weight: 600;
  }
}
</style>
